import type { Post } from '@/@types/post'
import type { MenuItemData } from '@/components/DropdownMenu/types'
import useUser from '@/utils/hooks/useUser'
import { useMemo } from 'react'
import { ACTION_MENU_LOCALE, ActionMenu } from '../config'

export default function useMoreActionsMenuData(data: Post) {
	const user = useUser(void 0)
	const currentUserId = user?.id
	return useMemo(() => {
		const menu: MenuItemData[] = []
		const isMyPost = currentUserId !== undefined && data.user?.id === currentUserId

		if (isMyPost) {
			if (data.pinned?.personalUpdate) {
				menu.push(ACTION_MENU_LOCALE[ActionMenu.UNPIN])
			} else {
				menu.push(ACTION_MENU_LOCALE[ActionMenu.PIN])
			}
		}

		if (data.collected) {
			menu.push(ACTION_MENU_LOCALE[ActionMenu.UNCOLLECT])
		} else {
			menu.push(ACTION_MENU_LOCALE[ActionMenu.COLLECT])
		}

		if (isMyPost) {
			if (data.privatizableStatus === 'ENABLE_RECOVER' && data.isPrivate) {
				menu.push(ACTION_MENU_LOCALE[ActionMenu.TO_PUBLIC])
			} else if (data.privatizableStatus === 'ENABLE_HIDE' && !data.isPrivate) {
				menu.push(ACTION_MENU_LOCALE[ActionMenu.TO_SELF_ONLY])
			}

			if (data.editableStatus === 'ENABLED') {
				menu.push(ACTION_MENU_LOCALE[ActionMenu.EDIT_POST])
			}

			menu.push(ACTION_MENU_LOCALE[ActionMenu.DELETE])
		}

		return menu
	}, [
		data.collected,
		data.editableStatus,
		data.isPrivate,
		data.pinned?.personalUpdate,
		data.privatizableStatus,
		data.user?.id,
		currentUserId,
	])
}
